import {
  Injectable,
  Inject
} from '@angular/core'
import { Location } from '@angular/common'
import { Router, NavigationEnd } from '@angular/router'

import { SessionService } from '../../services/session/session.service'
import { Logger } from '../../services/logger/logger.service'
import { HUB_URL, APP, WINDOW } from '../../variables'
import { EnvironmentService } from '../../services/environment.service'

import { SegmentService } from './segment.service'

const DEVELOPMENT = 'development'
const STAGING = 'staging'
const ACCEPT = 'accept'
const PRODUCTION = 'production'

@Injectable()
export class TrackingService {
  private hubEnv: string
  private role: string
  private user
  private account
  private userId: string;

  constructor(
    @Inject(HUB_URL) private hubUrl,
    @Inject(APP) private currentApp,
    @Inject(WINDOW) private window,
    private location: Location,
    private router: Router,
    private logger: Logger,
    private segmentService: SegmentService,
    private sessionService: SessionService,
    private environmentService: EnvironmentService,
  ) {
    if (this.sessionService.user == null) {
      console.log('No session found. Tracking will not start.')
      return
    }
    this.user = this.sessionService.user
    this.account = this.sessionService.account
    if (this.user.name === 'Public Link') {
      this.userId = this.account.id;
    } else {
      this.userId = this.user.id;
    }
    this.hubEnv = this.hubEnvironment()
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.initPageLoad(event.url)
      }
    })
  }

  track(name, value = {}) {
    value = value['value'] ? value : { value }
    if (this.environmentService.isDevMode()) {
      this.logger.debug('track', name, value)
    } else {
      const account = this.sessionService.account
      value['name'] = name
      value['timestamp'] = Date.now()
      value['env'] = this.hubEnv
      value['account'] = account.name
      value['hauptbahnhof_id'] = account.hauptbahnhofId
      value['app'] = this.currentApp

      const segmentTracker = this.segmentService.getInstance()
      segmentTracker.track(name, value)
    }
  }

  trackEvent(name, properties = {}) {
    if (this.environmentService.isDevMode()) {
      this.logger.debug('track event', name, properties)
    }
  }

  private hubEnvironment() {
    if (this.hubUrl === 'localhost' || this.hubUrl.includes('.dev') || this.hubUrl.includes('.test')) {
      return DEVELOPMENT
    } else if (this.hubUrl.includes(STAGING)) {
      return STAGING
    } else if (this.hubUrl.includes(ACCEPT)) {
      return ACCEPT
    } else {
      return PRODUCTION
    }
  }

  private initPageLoad(url) {
    const user = this.sessionService.user
    const account = this.sessionService.account

    let userData = {
      name: user.name,
      email: user.email,
      suite: user.suite,
      account: account.name,
      hauptbahnhof_id: account.hauptbahnhofId,
      role: user.role,
      env: this.hubEnv
    }

    if (this.environmentService.isDevMode()) {
      this.logger.debug('track', 'user', userData)
    }

    let hubData = {
      email: user.email,
      account: account.name,
      hauptbahnhof_id: account.hauptbahnhofId,
      app: this.currentApp,
      env: this.hubEnv,
      url: url
    }

    if (this.environmentService.isDevMode()) {
      this.logger.debug('track', 'hub', hubData)
    } else {
      const segmentTracker = this.segmentService.getInstance()
      segmentTracker.identify(this.userId, userData)
      segmentTracker.page(url, hubData)
    }
  }
}
